import React, { useEffect, useState } from 'react'
import {
	Box,
	Stack,
	Input,
	HStack,
	IconButton,
	Spinner,
	Center,
	Text,
	Alert,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Button,
	Select,
	useToast,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
	Icon,
	Collapse,
	VStack,
	SimpleGrid,
} from '@chakra-ui/react'
import {
	Pagination,
	usePagination,
	PaginationNext,
	PaginationPage,
	PaginationPrevious,
	PaginationContainer,
	PaginationPageGroup,
	PaginationSeparator,
} from '@ajna/pagination'
import AdminBlockCard from '../../components/AdminBlockCard'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import { GoSearch } from 'react-icons/go'
import { deleteRequest, getRequest } from '../../services/base.service'
import { IoIosArrowBack } from 'react-icons/io'
import { IoIosArrowForward } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { FiFilter } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import {
	setAdminSidebarFalseOnUrlChange,
	setCurrentPageHeading,
} from '../../redux/common/commonActions'
import SearchBox from '../../components/SearchBox'
import { Link } from 'react-router-dom'
import { FiEdit2, FiDelete } from 'react-icons/fi'
import { MdDeleteForever } from "react-icons/md";

const breadCrumb = [
	{ label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
	{ label: 'Location', isCurrentPage: false, link: '/admin/location' },
	{ label: 'State/Province', isCurrentPage: true },
]

const LocationState = () => {
	const navigate = useNavigate()

	const [stateList, setStateList] = useState([])
	const [countryList, setCountryList] = useState([])
	const [showMobileActions, setShowMobileActions] = useState(false)
	const [paginationProperty, setPaginationProperty] = useState({
		total: 1,
		currentPage: 1,
		pageSize: 1,
	})
	const [spinner, setSpinner] = useState({ status: true })
	const [queryParams, setQueryParams] = useState({ keyword: '' })
	const {
		pages,
		pagesCount,
		currentPage,
		setCurrentPage,
		isDisabled,
		setPageSize,
	} = usePagination({
		total: paginationProperty.total,
		limits: {
			outer: 2,
			inner: 2,
		},
		initialState: {
			pageSize: paginationProperty.pageSize,
			isDisabled: false,
			currentPage: 1,
		},
	})

	const [isLoading, setIsLoading] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [stateId, setStateId] = useState(null)
	const cancelRef = React.useRef()
	const toast = useToast()
	const dispatch = useDispatch()

	const onClose = () => {
		setIsOpen(false)
		setStateId(null)
	}

	const fetchCountryList = () => {
		getRequest(`countries`)
			.then((res) => setCountryList(res.result))
			.catch((err) => console.log('ERR: ', err))
	}

	useEffect(() => {
		fetchCountryList()
		dispatch(setCurrentPageHeading('State List'))
		dispatch(setAdminSidebarFalseOnUrlChange())
	}, [])

	useEffect(() => {
		fetchStateList({ ...queryParams, page: currentPage })
	}, [currentPage])

	const fetchStateList = (params = {}) => {
		setSpinner({ status: true })
		getRequest('admin/states', { params })
			.then((res) => {
				setStateList(res.result?.data)
				setPaginationProperty({
					total: res.result.total,
					currentPage: res.result.current_page,
					pageSize: res.result.per_page,
				})
				setPageSize(res.result.per_page)
				setSpinner({ status: false })
			})
			.catch((err) => {
				console.log('ERR: ', err)
				setSpinner({ status: true })
			})
	}

	const handlePageChange = (nextPage) => {
		setCurrentPage(nextPage)
	}

	const handleSearch = (e) => {
		e.preventDefault()
		setCurrentPage(1)
		fetchStateList({ ...queryParams, page: 1 })
	}

	const handleDelete = () => {
		setIsLoading(true)
		deleteRequest(`admin/states/${stateId}`)
			.then((res) => {
				setStateId(null)
				setIsLoading(false)
				toast({
					title: 'Successfully Deleted.',
					status: 'success',
					duration: 5000,
					isClosable: true,
				})
				onClose()
				fetchStateList({ ...queryParams, page: currentPage })
			})
			.catch((err) => {
				setStateId(null)
				setIsLoading(false)
				toast({
					title: 'Something Went Wrong.',
					status: 'error',
					duration: 5000,
					isClosable: true,
				})
				console.log('ERR: ', err)
				onClose()
			})
	}

	const handleReset = () => {
		const defaultQuery = { keyword: '', country: '' }
		setQueryParams(defaultQuery)
		setCurrentPage(1)
		fetchStateList({ ...defaultQuery, page: 1 })
	}


	return (
		<>
			<AdminBreadcrumb items={breadCrumb} />
			<SearchBox
					primaryActions={
						<>
							<HStack as={'form'} w="100%">
										<Input
											placeholder="Search..."
											w={['100%']} 
											size={'md'}
											borderColor={'gray.300'}
											rounded={'md'}
											value={queryParams.keyword || ''}
											onChange={(e) => {
												setQueryParams({
													...queryParams,
													keyword: e.target.value,
												})
											}}
										/>
										{/* <Box>
											<IconButton
												aria-label="Search"
												size={'md'}
												icon={<GoSearch />}
												variant={'brand'}
												type="submit"
												onClick={handleSearch}
											/>
										</Box> */}
							</HStack>
						</>
					}
					secondaryActions={
						<VStack as="form" spacing={4} w="100%" align="stretch">
							<SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} w="100%">

							
							<Select
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								placeholder="Select Country"
								value={queryParams.country || ''}
								onChange={(e) => {
									setQueryParams({
										...queryParams,
										country: e.target.value,
									})
								}}
							>
								{countryList.length > 0 &&
									countryList.map((country) => (
										<option key={country.id} value={country.id}>
											{country.name}
										</option>
									))}
							</Select>
							
							</SimpleGrid>
						
							{/* Buttons */}
							<HStack justify="flex-end" spacing={4}>
						
							<Button 
								variant="outline"
								colorScheme="gray" 
								size="md"				
								rounded={'md'}
								onClick={handleReset}
							>
								Reset
							</Button>
							<Button 
								variant={'brand'}
								size="md"
								rounded={'md'}
								type="submit"
								onClick={handleSearch}
							>
								Search
							</Button>
							</HStack>
						</VStack>
					}>
			</SearchBox>


			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onClose}
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							Delete City
						</AlertDialogHeader>

						<AlertDialogBody>
							Are you sure? You can't undo this action afterwards.
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onClose}>
								Cancel
							</Button>
							<Button
								isLoading={isLoading}
								loadingText={'DELETING...'}
								colorScheme="red"
								onClick={handleDelete}
								ml={3}
							>
								Delete
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>

			<Box py={'7'}>
				<AdminBlockCard
					title={'State/Province List'}
					// primaryActions={
					// 	<>
					// 	<HStack as={'form'}>
					// 		{/* <Select
					// 			w={'150px'}
					// 			size={'sm'}
					// 			display={['none', 'none', 'none', 'flex']}
					// 			borderColor={'gray.300'}
					// 			placeholder="Select Country"
					// 			onChange={(e) => {
					// 				setQueryParams({
					// 					...queryParams,
					// 					country: e.target.value,
					// 				})
					// 			}}
					// 		>
					// 			{countryList.length > 0 &&
					// 				countryList.map((country) => (
					// 					<option key={country.id} value={country.id}>
					// 						{country.name}
					// 					</option>
					// 				))}
					// 		</Select> */}
					// 		<HStack>
					// 			<Input
					// 				placeholder="Search..."
					// 				// display={['none', 'none', 'none', 'flex']}
					// 				w={['100%', '100%', '100%', '850px']}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				onChange={(e) => {
					// 					setQueryParams({ ...queryParams, keyword: e.target.value })
					// 				}}
					// 			/>

					// 			<Box display={['none', 'none', 'none', 'flex']}>
					// 				<IconButton
					// 					aria-label="Search"
					// 					size={'sm'}
					// 					icon={<GoSearch />}
					// 					variant={'brand'}
					// 					type="submit"
					// 					onClick={handleSearch}
					// 				/>
					// 			</Box>
					// 		</HStack>
					// 		<Icon
					// 			as={FiFilter}
					// 			display={[
					// 				'inline-block',
					// 				'inline-block',
					// 				'inline-block',
					// 				'none',
					// 			]}
					// 			onClick={() => {
					// 				setShowMobileActions(!showMobileActions)
					// 			}}
					// 			_hover={{ cursor: 'pointer' }}
					// 		/>
					// 	</HStack>
					// 	</>
					// }
					// secondaryActions={
					// 	<HStack wrap="wrap" spacing={2}>
					// 		<Select
					// 			w={'150px'}
					// 			size={'sm'}
					// 			display={['none', 'none', 'none', 'flex']}
					// 			borderColor={'gray.300'}
					// 			placeholder="Select Country"
					// 			onChange={(e) => {
					// 				setQueryParams({
					// 					...queryParams,
					// 					country: e.target.value,
					// 				})
					// 			}}
					// 		>
					// 			{countryList.length > 0 &&
					// 				countryList.map((country) => (
					// 					<option key={country.id} value={country.id}>
					// 						{country.name}
					// 					</option>
					// 				))}
					// 		</Select>
					// 	</HStack>
					// }
					// mobileActions={
					// 	<Collapse
					// 		in={showMobileActions}
					// 		unmountOnExit={true}
					// 		animateOpacity
					// 	>
					// 		<HStack>
					// 			<Select
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				placeholder="Select Country"
					// 				onChange={(e) => {
					// 					setQueryParams({
					// 						...queryParams,
					// 						country: e.target.value,
					// 					})
					// 				}}
					// 			>
					// 				{countryList.length > 0 &&
					// 					countryList.map((country) => (
					// 						<option key={country.id} value={country.id}>
					// 							{country.name}
					// 						</option>
					// 					))}
					// 			</Select>
					// 			{/* <HStack w={['100%', '100%', '100%', '100%']}>
					// 				<Input
					// 					placeholder="Search..."
					// 					w={['100%', '100%', '100%', '100%']}
					// 					size={'sm'}
					// 					borderColor={'gray.300'}
					// 					onChange={(e) => {
					// 						setQueryParams({
					// 							...queryParams,
					// 							keyword: e.target.value,
					// 						})
					// 					}}
					// 				/>

					// 				<Box>
					// 					<IconButton
					// 						aria-label="Search"
					// 						size={'sm'}
					// 						icon={<GoSearch />}
					// 						variant={'brand'}
					// 						type="submit"
					// 						onClick={handleSearch}
					// 					/>
					// 				</Box>
					// 			</HStack> */}
					// 		</HStack>
					// 	</Collapse>
					// }
				>
					{spinner.status ? (
						<Center>
							<Spinner color="red.500" size="xl" speed="0.6s" />
						</Center>
					) : stateList.length > 0 ? (
						<>
							<Stack gap={2} overflowX={'auto'} rounded={'md'} border={'1px'} borderColor="gray.200">
								<Table
									// variant="blackAlpha"
									// colorScheme={'whiteAlpha'}
									variant="simple"
									w={'100%'}
								>
									<Thead bg="gray.100">
										<Tr>
											<Th>#</Th>
											<Th>State/Province</Th>
											<Th>Country</Th>
											<Th isNumeric>Quantity Business</Th>
											<Th textAlign="right">Actions</Th>
										</Tr>
									</Thead>
									<Tbody>
										{stateList.map((state, index) => (
											<Tr key={state.id} bg={index % 2 === 0 ? 'gray.50' : 'white'}>
												<Td>{25 * (currentPage - 1) + (index + 1)}</Td>
												<Td>{state.name}</Td>
												<Td>{state.country.name}</Td>
												<Td isNumeric>{state.businesses_count}</Td>
												<Td>
													<HStack
														textAlign="right"
														align="right"
														justify="right"
														gap={2}
													>
														{/* <Button
															size="sm"
															colorScheme="teal"
															variant="outline"
															onClick={() => {
																navigate(
																	`/admin/location/edit/${'state'}/${state.id}`
																)
															}}
														>
															EDIT
														</Button> */}
														<Link to={`/admin/location/edit/${'state'}/${state.id}`}>
															<FiEdit2 cursor="pointer" />
														</Link>													
														{/* <Button
															size="sm"
															colorScheme="pink"
															variant="outline"
															onClick={() => {
																setStateId(state.id)
																setIsOpen(true)
															}}
														>
															DELETE
														</Button> */}
														<MdDeleteForever
															size={21}
															cursor="pointer"
															onClick={() => {
																setStateId(state.id)
																setIsOpen(true)
															}}
														/>															
													</HStack>
												</Td>
											</Tr>
										))}
									</Tbody>
								</Table>
							</Stack>
							<Pagination
								pagesCount={pagesCount}
								currentPage={currentPage}
								isDisabled={isDisabled}
								onPageChange={handlePageChange}
							>
								<PaginationContainer align="center" justify="center" p={4}>
									<PaginationPrevious
										px={'2'}
										py={'1'}
										_hover={{
											bg: 'gray.100',
										}}
										bg="white"
										color="gray.700"
										_disable={{ bg: 'white' }}
									>
										<Text>
											<IoIosArrowBack />
										</Text>
									</PaginationPrevious>
									<PaginationPageGroup
										isInline
										align={'center'}
										mx={'1'}
										separator={
											<PaginationSeparator fontSize="sm" w={7} jumpSize={11} />
										}
									>
										{pages.map((page) => (
											<PaginationPage
												w={7}
												h={7}
												bg={'gray.200'}
												border={'1px'}
												borderColor={'gray.300'}
												key={`pagination_page_${page}`}
												page={page}
												color={'black.500'}
												fontSize={'sm'}
												_hover={{
													bg: 'brand.600',
													color: 'white',
												}}
												_current={{
													bg: 'brand.500',
													fontSize: 'sm',
													color: 'white',
													borderColor: 'brand.500',
												}}
											/>
										))}
									</PaginationPageGroup>
									<PaginationNext
										w={7}
										h={7}
										_hover={{
											bg: 'gray.100',
										}}
										bg="white"
										color="gray.700"
										_disable={{ bg: 'white' }}
									>
										<Text>
											<IoIosArrowForward />
										</Text>
									</PaginationNext>
								</PaginationContainer>
							</Pagination>
						</>
					) : (
						<Alert status="error">
							<Center h={'100%'} w={'100%'}>
								NO DATA FOUND.
							</Center>
						</Alert>
					)}
				</AdminBlockCard>
			</Box>
		</>
	)
}

export default LocationState
